import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgInspired = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 128 40"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#000"
        d="M58 25.78h-2.323l-4.5-7.334v7.333H49v-11h2.468l4.355 7.04v-7.04H58zM107 26.621h-6V14.78h6v2.369h-4v2.368h4v2.368h-4v2.527h4v2.368zM111 14.78h3.051c3.813 0 5.949 2.377 5.949 5.5 0 3.12-2.441 5.5-5.797 5.5H111zm2.136 1.932v7.135h.762c2.441 0 3.966-1.487 3.966-3.568s-1.22-3.567-3.966-3.567h-.762M43 16.895v8.884h2v-11zM83 16.895v8.884h2v-11zM91.526 20.54v-3.68h1.106c1.578 0 2.21.64 2.21 1.76s-.474 1.92-2.21 1.92h-.948l3.632 6.08H98l-2.684-4.48q1.894-.72 1.894-3.36c0-1.76-1.736-4-4.42-4H89v12h2.368V20.7zM76 14.78h-4v11h2.308V22.7h1.538c2.308 0 4.154-1.76 4.154-3.96s-1.846-3.96-4.154-3.96zm-.154 5.866h-1.538v-3.667h1.538c1.077 0 2 .733 2 1.907s-.77 1.907-2 1.907zM65.528 19.64h-.302c-1.056-.456-1.962-.76-1.962-1.52 0-.759.604-1.214 1.51-1.214.905 0 .754 0 1.056.152.302 0 .755.455 1.057.76h.15c0-.153 1.36-1.52 1.36-1.52-.756-.76-1.812-1.519-3.623-1.519S61 16.146 61 18.121s1.811 2.886 3.17 3.342h.15c1.057.455 2.114.76 2.114 1.519 0 .76-.453 1.367-1.51 1.367h-.603s-.906-.152-1.962-1.215L61 24.653c1.208 1.367 2.113 1.67 2.264 1.822.604.152 1.057.304 1.812.304 1.207 0 2.113-.456 2.867-1.063.604-.608 1.057-1.52 1.057-2.43 0-2.127-1.66-2.887-3.32-3.342zM36.625 23.33 27 21.78l2.444 9L38 23.64z"
      />
      <path fill="#000" d="m8 18.75 22 12.03-6.78-20" />
    </svg>
  );
};
export default SvgInspired;
